export default __webpack_public_path__ + "static/IMG_4275-b10867f4cf658ecbae146260c842e03e.jpg";